import { useEffect, useState } from "react";
import FloatingLabelInput from "../../Common/FloatingLabel";
import FloatingLabelDropdown from "../../Common/FloatingLabelDropdown";
import { options } from "../../json/List";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { EditPersonalDetails } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Spinner from "../../Common/Spinner";
import { GetPersonalDetails, GetRelationship } from "../../api/get";
import Header from "../../Common/Header";
import Loader from "../../loader";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { FaInfoCircle } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";

const YourSelf = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [relationship, setRelationship] = useState({});
  const [touched, setTouched] = useState(false);
  const [errors, setErrors] = useState({});
  const [YourselfData, setYourSelfData] = useState({});
  const [loading, setLoading] = useState(false);
  const [contentLoder, setContentLoader] = useState(true);
  const [date, setDate] = useState("");
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const navigate = useNavigate();
  const [showSecondAddress, setShowSecondAddress] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    // Fetch personal details and relationships and set form values once loaded
    Promise.all([GetPersonalDetails(), GetRelationship()])
      .then(([personalDetails, relationshipOptions]) => {
        if (
          personalDetails.success &&
          relationshipOptions.success &&
          personalDetails.status_code === "200" &&
          relationshipOptions.status_code === "200"
        ) {
          setYourSelfData(personalDetails.data); // Set YourselfData with the fetched details
          // formik.setValues(personalDetails.data);
          setRelationship(
            relationshipOptions.data.map((item) => ({
              value: item.id,
              label: item.name,
            }))
          );
          setContentLoader(false);
        } else if (!personalDetails.success) {
          handleApiError(personalDetails, navigate); // Use helper function
        } else if (!relationshipOptions.success) {
          handleApiError(relationshipOptions, navigate); // Use helper function
        }
      })
      .catch((err) => console.error("Error fetching data", err));
  }, []);
  console.log("YourselfData=>", YourselfData);
  // console.log("relationship=>", relationship);
  useEffect(() => {
    if (Object.keys(YourselfData).length > 0 && relationship.length > 0) {
      // console.log("Both YourselfData and relationship have data:");
      setContentLoader(false);
    }
  }, [YourselfData, relationship]);
  // Helper function to convert dd/mm/yyyy to yyyy-mm-dd
  const formatDateToYMD = (date) => {
    const [day, month, year] = date.split("/");
    return `${year}-${month}-${day}`;
  };
  // Yup validation schema
  const validationSchema = Yup.object().shape({
    user_prefix: Yup.string().required("Required field"),
    first_name: Yup.string().required("Required field"),
    last_name: Yup.string().required("Required field"),
    date_of_birth: Yup.string()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .required("Required field")
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      )
      .test(
        "is-over-18",
        "Sorry, but your partner needs to be over 18.",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          const enteredDate = new Date(`${year}-${month}-${day}`);
          const today = new Date();
          const age = today.getFullYear() - enteredDate.getFullYear();
          const isBirthdayPassed =
            today.getMonth() > enteredDate.getMonth() ||
            (today.getMonth() === enteredDate.getMonth() &&
              today.getDate() >= enteredDate.getDate());
          return age > 18 || (age === 18 && isBirthdayPassed);
        }
      ),
    address_line_1: Yup.string().required("Required field"),
    postcode: Yup.string().required("Required field"),
    city: Yup.string().required("Required field"),
    relationship_id: Yup.string().required("Required field"),
    phone_number: Yup.string()
      .matches(/^\d+$/, "Phone Number must be numeric")
      .min(10, "Phone Number must be at least 10 digits")
      .max(10, "Phone Number cannot exceed 10 digits"),
  });
  const formik = useFormik({
    initialValues: {
      user_prefix: YourselfData?.user_prefix || "",
      first_name: YourselfData?.first_name || "",
      last_name: YourselfData?.last_name || "",
      date_of_birth: YourselfData?.dob
        ? new Date(YourselfData.dob).toLocaleDateString("en-GB")
        : "",
      address_line_1: YourselfData?.address_line_1 || "",
      address_line_2: YourselfData?.address_line_2 || "",
      postcode: YourselfData?.postcode || "",
      city: YourselfData?.city || "",
      relationship_id: YourselfData?.relationship_id || "",
      phone_number: YourselfData?.phone_number || "",
    },
    validationSchema, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values) => {
      // Convert "date_of_birth" from "dd/mm/yyyy" to "dob" with "dd-mm-yyyy"
      const transformedValues = {
        ...values,
        dob: formatDateToYMD(values.date_of_birth),
      };
      delete transformedValues.date_of_birth; // Remove the old field
      EditPersonalDetails(transformedValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            // toast.success("Personal Details Updated Successfully");
            navigate("/make-will-online/about-yourself/partner");
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  return (
    <>
      {contentLoder ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <div>
                    <h4 className="mt-[20px] font-bold text-[26px] sm:text-[30px] lg:text-[34px]">
                      Tell us about yourself
                    </h4>
                    <p className="text-slate-500 my-2">
                      This bit’s important, as it helps to make it clear that
                      this is genuinely your will. Double-check your spelling
                      and details to be safe.
                    </p>
                  </div>
                  <div className="flex gap-5 mt-[30px]">
                    <div className="w-[30%]">
                      <FloatingLabelDropdown
                        label="Title"
                        options={options}
                        value={formik.values.user_prefix}
                        onChange={(e) =>
                          formik.setFieldValue("user_prefix", e.target.value)
                        }
                        name="user_prefix"
                        error={
                          formik.touched.user_prefix &&
                          formik.errors.user_prefix
                        }
                      />
                    </div>
                    <div className="w-[35%]">
                      <FloatingLabelInput
                        label="First Name"
                        type="text"
                        name="first_name"
                        value={formik.values.first_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.first_name && formik.errors.first_name
                        }
                      />
                    </div>

                    <div className="w-[35%]">
                      <FloatingLabelInput
                        label="Last Name"
                        type="text"
                        name="last_name"
                        value={formik.values.last_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.last_name && formik.errors.last_name
                        }
                      />
                    </div>
                  </div>
                  <div className="w-full mt-5">
                    <div className="relative w-full border-2 h-[60px] flex items-center">
                      <MaskedInput
                        mask={[
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        placeholder={
                          isFocused || formik.values.date_of_birth
                            ? "dd/mm/yyyy"
                            : ""
                        }
                        pipe={autoCorrectedDatePipe}
                        value={formik.values.date_of_birth}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onChange={(e) =>
                          formik.setFieldValue("date_of_birth", e.target.value)
                        }
                        className="block text-black  w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                        name="date_of_birth"
                      />
                      <label
                        htmlFor="dob"
                        className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                      >
                        Date of birth
                      </label>
                    </div>
                  </div>
                  {formik.touched.date_of_birth &&
                  formik.errors.date_of_birth ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formik.errors.date_of_birth}
                      </p>
                    </div>
                  ) : null}

                  <div className="mt-5 border-2 border-dashed"></div>
                  <div className="pt-5">
                    <p className="text-[18px] font-bold">
                      What’s your full address?
                    </p>
                    <p className="text-slate-500 text-[16px] py-2">
                      Make sure to enter your full address including your
                      postcode. You can manually type your address if needed.
                    </p>
                    <p className="text-slate-500 text-[16px] py-2">
                      Your full address is required to register your will with
                      the National Will Registry.
                    </p>
                  </div>
                  {!showSecondAddress ? (
                    <div className="first_address">
                      <div className="mt-5 mb-4">
                        <FloatingLabelInput
                          label="Search for an address or postcode"
                          type="text"
                          id="address_or_postcode"
                          name="address_or_postcode"
                          value={YourselfData?.address_or_postcode}
                          error={errors.address_or_postcode}
                          onChange={formik.handleChange}
                          // onChange={(e) => handleChange(e)}
                        />
                      </div>
                      <button
                        className="underline"
                        onClick={() => setShowSecondAddress(true)}
                      >
                        or add the address manually
                      </button>
                    </div>
                  ) : (
                    <div className="second_address">
                      <div className="mt-5 mb-4">
                        <FloatingLabelInput
                          label="Address line 1"
                          type="text"
                          id="address_1"
                          name="address_line_1"
                          value={formik.values.address_line_1}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.address_line_1 &&
                            formik.errors.address_line_1
                          }
                        />
                      </div>
                      <div className="mt-5 mb-1">
                        <FloatingLabelInput
                          label="Address line 2 (Optional)"
                          type="text"
                          id="address_2"
                          name="address_line_2"
                          value={formik.values.address_line_2}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                      <div className="flex items-center gap-5 ">
                        <div className="mt-5 mb-4 w-[40%]">
                          <FloatingLabelInput
                            label="Postcode"
                            type="text"
                            id="pincode"
                            name="postcode"
                            value={formik.values.postcode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.postcode && formik.errors.postcode
                            }
                          />
                        </div>
                        <div className="mt-5 mb-4 w-[60%]">
                          <FloatingLabelInput
                            label="City"
                            type="text"
                            id="city"
                            name="city"
                            value={formik.values.city}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.city && formik.errors.city}
                          />
                        </div>
                      </div>
                      <button
                        className="underline"
                        onClick={() => setShowSecondAddress(false)}
                      >
                        or search by street or postcode
                      </button>
                    </div>
                  )}
                  <div>
                    <div className="py-5 border-b-2 border-dashed">
                      <p className="text-[18px] font-bold">
                        What is your relationship status?
                      </p>
                      <p className="text-slate-500 text-[16px] py-2">
                        Enter your current relationship status. For example, if
                        you are previously divorced and now with a new partner
                        you would enter “With a partner, but not married”
                      </p>
                      <div className="my-2">
                        <FloatingLabelDropdown
                          label="Select Marrital Status"
                          options={relationship}
                          value={formik.values.relationship_id}
                          onChange={formik.handleChange}
                          name="relationship_id"
                          error={
                            formik.touched.relationship_id &&
                            formik.errors.relationship_id
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <p className="text-slate-500 text-[16px] py-5">
                        This is optional, and we’ll never call you unless you
                        ask for help with your will.
                      </p>
                      <div className="mt-1 pb-[30px] border-b-2 ">
                        <FloatingLabelInput
                          label="Your Phone Number"
                          type="text"
                          id="phone_number"
                          name="phone_number"
                          value={formik.values.phone_number}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.phone_number &&
                            formik.errors.phone_number
                          }
                        />
                      </div>
                    </div>

                    <div className="flex justify-between  my-3">
                      <Link to={"/dashboard"}>
                        <button className="flex items-center justify-center gap-1 font-semiold text-[20px] py-2 rounded-[10px] mt-5 text-slate-500">
                          <FaAngleLeft />
                          Back
                        </button>
                      </Link>
                      {loading === false ? (
                        // <Link to={"/your-partner"}>
                        <button
                          onClick={() => setShowSecondAddress(true)}
                          className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                          type="submit"
                        >
                          Next <FaChevronRight />
                        </button>
                      ) : (
                        // </Link>
                        <button className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded">
                          <Spinner />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
              <div className="max-lg:hidden bg-no-repeat">
                <div className="fixed top-0 w-[500px] right-[6%] bg-cloud">
                  <img src="/assets/images/4.png" alt="mascot" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default YourSelf;
